export var FieldNames;
(function (FieldNames) {
})(FieldNames || (FieldNames = {}));
export const defaultFormValues = {};
